export const AuthConstants = {
	LOGIN: "AUTH_LOGIN",
	SUCCESS: "AUTH_SUCCESS",
	FAILED: "AUTH_FAILED",
	UPDATE: "SET_PROFILE",
	REFRESH_TOKEN: "REFRESH_TOKEN",
	REFRESH_TOKEN_FAILED: "REFRESH_TOKEN_FAILED",
	CLEAR: "AUTH_CLEAR",
};
export const ForgotPasswordConstants = {
	REQUEST: "FORGOT_PASSWORD_REQUEST",
	SUCCESS: "FORGOT_PASSWORD_SUCCESS",
	FAILED: "FORGOT_PASSWORD_FAILED",

	VERIFY_OTP_REQUEST: "CONFIRM_OTP_REQUEST",
	VERIFY_OTP_SUCCESS: "CONFIRM_OTP_SUCCESS",
	VERIFY_OTP_FAILED: "CONFIRM_OTP_FAILED",

	RESEND_OTP_REQUEST: "RESEND_OTP_REQUEST",
	RESEND_OTP_SUCCESS: "RESEND_OTP_SUCCESS",
	RESEND_OTP_FAILED: "RESEND_OTP_FAILED",

	RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
	RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
	RESET_PASSWORD_FAILED: "RESET_PASSWORD_FAILED",
};
